import { delData, getData, postData, putData } from '../../../shared/api/core';

export const getCountry = (countryCode) =>
  getData(`/master-data/countries/${countryCode}`);

export const getPortsByCountry = (countryCode) =>
  getData(`/master-data/countries/${countryCode}/ports`);

export const getCountries = () => getData(`/master-data/countries`);

export const getLpSuppliers = (params) =>
  getData(
    `/master-data/lp-suppliers?${new URLSearchParams(params).toString()}`
  );

export const getPorts = () => getData(`/master-data/ports`);

export const getLpSupplierPortMapping = async (supplierNo) =>
  getData(`/master-data/supplier-port-mappings/supplier/${supplierNo}`);

export const addLpSupplierPortMapping = async (data) =>
  postData(`/master-data/supplier-port-mappings`, data);

export const delLpSupplierPortMapping = async (id) =>
  delData(`/master-data/supplier-port-mappings/${id}`);

export const getMarkets = () => getData(`/master-data/market`);

export const getShips = () => getData(`/master-data/ship`);

export const getShip = (imo) => getData(`/master-data/ship/${imo}`);

export const addShip = (data) => postData(`/master-data/ship`, data);

export const updateShip = (imo, data) =>
  putData(`/master-data/ship/${imo}`, data);

export const deleteShip = (imo) => delData(`/master-data/ship/${imo}`);

export const getHolds = () => getData(`/master-data/hold`);
